import {
  Card,
  Divider,
  Stack,
  type Theme,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material"
import type { HealthMission } from "../healthMission.model"
import { MissionProgressBar } from "./MissionProgressBar"
import { ProgressGoalCard } from "./ProgressGoalCard"
import { ProgressMessage } from "./ProgressMessage"

export const HealthMissionProgressCard = ({
  goalProgress,
  missionCount,
}: HealthMission) => {
  const isCompact = useMediaQuery((theme: Theme) =>
    theme.breakpoints.between("sm", "md"),
  )
  const { goals } = goalProgress

  return (
    <CardLayout sx={{ width: "100%" }}>
      <CardTitle>suivi de progression</CardTitle>
      <MissionProgressBar {...goalProgress} missionCount={missionCount} />

      <ProgressGoalCardContainer
        isCompact={isCompact}
        divider={
          <Divider flexItem orientation={isCompact ? "horizontal" : "vertical"} />
        }
      >
        {goals.map(({ type, value, reached }, index) => (
          <ProgressGoalCard
            key={type}
            cardNumber={goals.length > 1 ? index + 1 : undefined}
            actCount={value}
            isChecked={reached}
          />
        ))}
      </ProgressGoalCardContainer>
      <ProgressMessage
        goalProgress={goalProgress}
        missionCount={missionCount}
        mt={3}
      />
    </CardLayout>
  )
}

const CardLayout = styled(Card)(({ theme }) => ({
  border: "none",
  borderRadius: theme.spacing(1.25),
  padding: theme.spacing(3),
}))

const CardTitle = styled(Typography)(({ theme }) => ({
  textTransform: "uppercase",
  fontWeight: 600,
  marginBottom: theme.spacing(1.75),
  fontSize: theme.typography.pxToRem(11),
}))

const ProgressGoalCardContainer = styled(Stack, {
  shouldForwardProp: (props) => props !== "isCompact",
})<{ isCompact: boolean }>(({ theme: { spacing }, isCompact }) => ({
  flexDirection: isCompact ? "column" : "row",
  paddingInline: spacing(2),
  gap: spacing(2),
}))
